import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { STORE_PROMOTION_SETTINGS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const updateStorePromotionSettingStatusAction = createAsyncThunk(
    'price/updateStorePromotionSettingStatusAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.patch(`${ STORE_PROMOTION_SETTINGS_PATH }/${ data.type }/${ data.podId }/status`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updateStorePromotionSettingStatusSlice = createSlice({
    name: 'updateStorePromotionSettingStatusSlice',
    initialState: DEFAULT_STATE,
    extraReducers: builder => {
        builder.addCase(updateStorePromotionSettingStatusAction.pending, () => STATE__API__STARTED);
        builder.addCase(updateStorePromotionSettingStatusAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updateStorePromotionSettingStatusAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updateStorePromotionSettingStatusState = (state) => state.price.updateStorePromotionSettingStatus;
export default updateStorePromotionSettingStatusSlice.reducer;